const ADMIN_SESSION_KEY = 'loginAsAdmin';

export function startLoginAs({user, token}, navigate = path => window.location.assign(path)) {
  const admin = JSON.parse(localStorage.getItem('user') || 'null');
  if (admin?.role !== 'admin' || !admin.token || !user || !token) {
    throw new Error('Unable to switch accounts. Sign in as an administrator and try again.');
  }
  sessionStorage.setItem(ADMIN_SESSION_KEY, JSON.stringify(admin));
  localStorage.setItem('user', JSON.stringify({...user, token, impersonatedBy: admin._id}));
  // Reload so cached data and permission flags from the admin session are discarded.
  navigate('/');
}

export function canReturnToAdmin() {
  return Boolean(sessionStorage.getItem(ADMIN_SESSION_KEY));
}

export function clearLoginAsSession() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}

export function returnToAdmin(navigate = path => window.location.assign(path)) {
  const admin = sessionStorage.getItem(ADMIN_SESSION_KEY);
  if (!admin) return;
  localStorage.setItem('user', admin);
  clearLoginAsSession();
  navigate('/users');
}
